export default __webpack_public_path__ + "static/assets/goback_arrow.ed5b334b.png";